export default [
  {
    path: "/audit",
    name: "AuditOverview",
    component: () => import("@/views/audit/AuditOverview"),
    meta: { title: "audit.overview.title", requiresAuth: true },
  },
]
